export default function absoluteURL(href) {
  const link = document.createElement('a');
  link.href = href;
  return link.href;
}
